import { ShieldCheck, AlertTriangle, HelpCircle } from "lucide-react";

const TONE = {
  high:   { bg: "bg-emerald-100 text-emerald-800 border-emerald-200", icon: ShieldCheck, label: "High" },
  medium: { bg: "bg-amber-100 text-amber-800 border-amber-200",       icon: ShieldCheck, label: "Medium" },
  low:    { bg: "bg-rose-100 text-rose-800 border-rose-200",         icon: AlertTriangle, label: "Low · Manual Verification Required" },
};

export const LOW_CONFIDENCE_MESSAGE =
  "Property size requires manual review. Final price may be adjusted after verification.";

/**
 * Compact pill showing the mowable-area confidence score.
 * Used on admin booking cards + booking detail + route planning + customer
 * estimate (limited info — never reveal raw parcel data to customers).
 */
export default function ConfidenceChip({ confidence, pct, audience = "admin", className = "" }) {
  const key = String(confidence || "").toLowerCase();
  const t = TONE[key];
  if (!t) {
    return (
      <span className={`inline-flex items-center gap-1 text-[10px] font-extrabold uppercase tracking-[0.12em] px-2 py-0.5 rounded-full border bg-gray-100 text-gray-600 border-gray-200 ${className}`} data-testid="confidence-chip-unknown">
        <HelpCircle className="w-3 h-3" /> No data
      </span>
    );
  }
  const Icon = t.icon;
  // Customers should NEVER see the raw confidence pct or "Low" label verbatim;
  // they only see a friendly "Verified" / "Pending verification" badge.
  if (audience === "customer") {
    if (key === "low") {
      return (
        <span className={`inline-flex items-center gap-1 text-[10px] font-extrabold uppercase tracking-[0.12em] px-2 py-0.5 rounded-full border bg-amber-100 text-amber-800 border-amber-200 ${className}`} data-testid="confidence-chip-customer-low">
          <AlertTriangle className="w-3 h-3" /> Pending verification
        </span>
      );
    }
    return (
      <span className={`inline-flex items-center gap-1 text-[10px] font-extrabold uppercase tracking-[0.12em] px-2 py-0.5 rounded-full border bg-emerald-100 text-emerald-800 border-emerald-200 ${className}`} data-testid="confidence-chip-customer-verified">
        <ShieldCheck className="w-3 h-3" /> Verified
      </span>
    );
  }
  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] font-extrabold uppercase tracking-[0.12em] px-2 py-0.5 rounded-full border ${t.bg} ${className}`}
      data-testid={`confidence-chip-${key}`}
      title={pct ? `Confidence ${pct}%` : undefined}
    >
      <Icon className="w-3 h-3" /> {t.label}{pct ? ` · ${pct}%` : ""}
    </span>
  );
}
